const TRANSCRIPTION_AWS_COST_PER_NOTE = 0.02;
const CODING_AWS_COST_PER_REQUEST = 0.01;
const LOMN_AWS_COST_PER_REQUEST = 0.01;

const TRANSCRIPTION_OPENAI_COST_PER_NOTE = 0.015;
const CODING_OPENAI_COST_PER_REQUEST = 0.05;
const LOMN_OPENAI_COST_PER_REQUEST = 0.12;

export function estimateCostsForUser(row) {
  const transcribedCount = Number(row?.transcribedCount || 0);
  const codingSubmittedCount = Number(row?.codingSubmittedCount || 0);
  const lomnSubmittedCount = Number(row?.lomnSubmittedCount || 0);

  const estimatedAwsCost =
    transcribedCount * TRANSCRIPTION_AWS_COST_PER_NOTE +
    codingSubmittedCount * CODING_AWS_COST_PER_REQUEST +
    lomnSubmittedCount * LOMN_AWS_COST_PER_REQUEST;

  const estimatedOpenAiCost =
    transcribedCount * TRANSCRIPTION_OPENAI_COST_PER_NOTE +
    codingSubmittedCount * CODING_OPENAI_COST_PER_REQUEST +
    lomnSubmittedCount * LOMN_OPENAI_COST_PER_REQUEST;

  return {
    estimatedAwsCost,
    estimatedOpenAiCost,
    estimatedTotalCost: estimatedAwsCost + estimatedOpenAiCost,
  };
}

export function attachCostEstimates(userRows) {
  return userRows.map((row) => ({
    ...row,
    ...estimateCostsForUser(row),
  }));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);
}
